/* eslint-disable */
import requestDev from '@/utils/requestDev'
import { APIReportPHP } from '@/utils/servicesApi'
const qs = require('qs')
export function TotalTokenAI(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/total-tokenai',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function sentMessagesAnnually(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/sent-messages-annually',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function statAIChat(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/stat-aichat',
        method: 'GET',
        data: qs.stringify(params)
    })
}
export function statAIChatSummary(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/stat-aichatsummary',
        method: 'GET',
        data: qs.stringify(params)
    })
}
export function statAIChatBot(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/stat-aichatbot',
        method: 'GET',
        data: qs.stringify(params)
    })
}
export function waRotator(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/wa-rotator',
        method: 'GET',
        data: qs.stringify(params)
    })
}
export function masterOperator(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/master-operator',
        method: 'GET',
        data: qs.stringify(params)
    })
}
export function contactGroup(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/contact-group',
        method: 'GET',
        data: qs.stringify(params)
    })
}
export function momentSpesial(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/moment-spesial',
        method: 'GET',
        data: qs.stringify(params)
    })
}


// WEBPACK FOOTER //
// ./src/api/dashboard.js